module.exports = __webpack_public_path__ + "static/popup-ea2722a88c8ec4de50cd626f4eefca30.png";